import React, { useState } from 'react'
import "./style.scss"

import AddIcon from "../image/addAvatar.png"
import { useNavigate, Link } from 'react-router-dom'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../firebase'

const Login = () => {

    const [err, setErr] = useState(false)

    const navigate = useNavigate()

    const handleSubmit = async (e) => {

        e.preventDefault()
        const email = e.target[0].value
        const password = e.target[1].value


        try {

            await signInWithEmailAndPassword(auth, email, password)
            navigate("/")

        } catch (error) {
            setErr(true)
        }

    }


    return (
        <div className="formContainer">
            <div className="formWrapper">
                <span className="logo">CHAT APP</span>
                <span className="title">Sign In</span>
                <form onSubmit={handleSubmit}>
                    <input type="email" placeholder="Email" />
                    <input type="password" placeholder="Password" />


                    <button>Sign In</button>
                    {err && <span>Something went wrong!</span>}

                </form>
                <p>You don't have account? <Link to="/register">Register</Link></p>
            </div>
        </div>
    )
}

export default Login